"use client"

import { useState } from "react"
import { reviews } from "@/app/content/landing"
import { ChevronLeft, ChevronRight } from "@/app/components/icons"
import { iconButtonClass } from "@/app/components/styles"

export function ReviewRail() {
  const [index, setIndex] = useState(0)
  const review = reviews[index]

  function shift(direction: -1 | 1) {
    setIndex((current) => (current + direction + reviews.length) % reviews.length)
  }

  return (
    <div>
      <figure className="rounded-[28px] bg-surface p-6 sm:p-10">
        <blockquote className="max-w-3xl text-xl leading-relaxed font-medium tracking-tight sm:text-2xl">
          «{review.text}»
        </blockquote>
        <figcaption className="mt-8">
          <p className="font-semibold">{review.name}</p>
          <p className="mt-1 text-sm text-muted">{review.role}</p>
        </figcaption>
      </figure>
      <div className="mt-5 flex flex-wrap items-center justify-between gap-4">
        <div className="flex gap-2">
          <button
            type="button"
            className={iconButtonClass}
            aria-label="Предыдущий отзыв"
            onClick={() => shift(-1)}
          >
            <ChevronLeft />
          </button>
          <button
            type="button"
            className={iconButtonClass}
            aria-label="Следующий отзыв"
            onClick={() => shift(1)}
          >
            <ChevronRight />
          </button>
        </div>
        <div className="flex flex-wrap gap-2" role="tablist" aria-label="Авторы отзывов">
          {reviews.map((item, itemIndex) => {
            const selected = itemIndex === index
            return (
              <button
                key={item.id}
                type="button"
                role="tab"
                aria-selected={selected}
                className={`cursor-pointer rounded-full px-3 py-1.5 text-sm transition-colors ${
                  selected ? "bg-foreground text-white" : "bg-surface text-muted hover:text-foreground"
                }`}
                onClick={() => setIndex(itemIndex)}
              >
                {item.name.split(" ")[0]}
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}
